import { Col, Skeleton } from "antd";
import React, { useEffect, useState } from "react";
import apiPath from "../../constants/apiPath";
import { useAppContext } from "../../context/AppContext";
import lang from "../../helper/langHelper";
import { Severty, ShowToast } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";
import { UserWeeklyChart } from "../../components/chart/_Weeklychart";
import SectionWrapper from "../../components/SectionWrapper";
import moment from "moment";

const dummy = {
  labels: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],
  datasets: [
    {
      label: "Dataset 1",
      data: [
        null,
        null,
        null,
        null,
        null,
        16000,
        null,
        5000,
        null,
        null,
        null,
        null,
      ], // Starting from June
      borderColor: "#CE9944",
      tension: 0.1,
      spanGaps: true, // Add this option
    },
    {
      label: "Dataset 2",
      data: [
        null,
        null,
        null,
        null,
        null,
        7000,
        null,
        8000,
        null,
        null,
        null,
        null,
      ], // Starting from June
      borderColor: "#CE9944",
      backgroundColor: "#CE9944",
      
      spanGaps: true, // Add this option
      // yAxisID: 'y1',
    },
  ],
};

const getLastSixWeeks = () => {
  const lastSixWeeks = [];
  for (let i = 5; i >= 0; i--) {
    const startDate = moment().subtract(i, "weeks").startOf("isoWeek");
    const weekNumber = startDate.isoWeek();
    lastSixWeeks.push({
      startDate: startDate.format("YYYY-MM-DD"),
      weekNumber: weekNumber,
    });
  }
  return lastSixWeeks;
};

const WeeklyChartSection = () => {
  const { country } = useAppContext();
  const { request } = useRequest();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [years, setYears] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [filter, setFilter] = useState({
    country_id: undefined,
    city_id: undefined,
    year: undefined,
    month: undefined,
  });

 

  const fetchData = () => {
    request({
      url: `${apiPath.dashboard}/graph?period=weekly${
        filter.year ? `&year=${filter.year}` : ``
      }`,
      method: "GET",
      onSuccess: ({ data, status }) => {
        setLoading(false);
        console.log(data, "weeklyyyyy");
        if (status) {
          setData(data);
        }
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  useEffect(() => {
    fetchData();
  }, []);


  return (
    <>
      {loading ? [1, 2].map((item) => <Skeleton active key={item} />)
        : <>
        {/* <p>{lang("Earnings")}</p> */}

          <Col xs={24} xl={12} lg={24} className="mb-24">
            <SectionWrapper
              cardHeading={lang("Bookings")}
              extra={
                <>
                  <div className="w-100 text-head_right_cont">
                    <div className="role-wrap"></div>
                  </div>
                </>
              }
            >
              <UserWeeklyChart data={data?.bookings || []} />
            </SectionWrapper>
          </Col>

          <Col xs={24} xl={12} lg={24} className="mb-24">
            <SectionWrapper
              cardHeading={lang("Orders")}
              extra={
                <>
                  <div className="w-100 text-head_right_cont">
                    <div className="role-wrap"></div>
                  </div>
                </>
              }
            >
              <UserWeeklyChart data={data?.orders || []} />
            </SectionWrapper>
          </Col>

       
        </>
      }
    </>
  );
};

export default WeeklyChartSection;
